import React, { Component } from 'react';
import Form from 'react-bootstrap/lib/Form';
import { FieldArray } from 'formik';
import { Button } from '../../Button';
import { ButtonLoader } from '../../ButtonLoader';
import { Select } from '../../Select';
import { ThematicAreaDropdownOption, DefaultOffice, DistrictDropdownOption } from '../../../utils/enums';
import { AttachmentItem } from '../AttachmentItem';
import { InitiativeMode } from '../../../utils/enums';
// import ReCaptcha from '../../ReCaptchaWrapper';

export class ContactListItemConsultationProposalInitiative extends Component {
	constructor(props) {
		super(props);
		this.captcha = null;
	}

	verify = async () => await this.captcha.verify();

	render() {
		const props = this.props;
		const { disabled = false } = props;
		return (
			<div className="box margin-top-20">
				<div className="container initiative">
					<div className="initiative-column--100">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="content" className="field__label">
									Treść
								</Form.Label>
								<Form.Control
									as="textarea"
									rows="10"
									id="content"
									name="content"
									value={props.content}
									onChange={props.onChange}
									className="field__textarea"
									onBlur={props.onBlur}
									placeholder="Treść"
									title="Wpisz treść inicjatywy"
									isInvalid={!!props.errors.content}
									autocomplete="off"
									disabled={disabled}
								/>
							</div>
							{typeof props.errors.content === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.content}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</div>
				</div>
				<div className="buttons margin-top-20" />
				<FieldArray
					id="attachments"
					name="attachments"
					render={(arrayHelpers) => (
						<AttachmentItem
							maxSize={props.attachmentConfiguration.maxAttachmentSize * 1024 * 1024}
							disabled={disabled}
							items={props.attachments}
							removeable={true}
							baseUrl={'/api/attachments/initiative-attachement'}
							uploadFile={props.uploadFile}
							onAddItem={arrayHelpers.push}
							onRemoveItem={arrayHelpers.remove}
						/>
					)}
				/>
				{typeof props.errors.attachments === 'string' && (
					<Form.Control.Feedback type="invalid" className="field--invalid">
						{props.errors.attachments}
					</Form.Control.Feedback>
				)}

				{!props.isAuth && (
					<div className="buttons margin-top-20">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="replyTo" className="field__label">
									Adres e-mail
								</Form.Label>
								<Form.Control
									id="replyTo"
									name="replyTo"
									value={props.replyTo}
									onChange={props.onChange}
									className="field__input"
									onBlur={props.onBlur}
									placeholder="Adres e-mail"
									title="Wpisz adres e-mail"
									isInvalid={!!props.errors.replyTo}
									disabled={disabled}
								/>
							</div>
							{typeof props.errors.replyTo === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.replyTo}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</div>
				)}
				<div className="buttons margin-top-20">
					<ButtonLoader
						type="submit"
						variant="danger"
						disabled={!props.isValid || props.isInitiativeCreating || disabled}
						text={'Wyślij'}
						executingText={'Wysyłanie'}
						isExecuting={props.isInitiativeCreating}
					/>
					<button
						type="reset"
						className="button button--primary-dark button--16 button--width-auto button--bordered-transparent button--blue"
						disabled={props.isInitiativeCreating || disabled}
					>
						Anuluj
					</button>
				</div>
			</div>
		);
	}
}

ContactListItemConsultationProposalInitiative.defaultProps = {
	title: '',
	content: '',
	replyTo: '',
	attachments: [],
	attachmentConfiguration: {
		maxAttachmentQuantity: 3,
		maxAttachmentSize: 5,
		maxAllAttachmentsSize: 15
	},
	cost: 0,
	thematicAreaId: ThematicAreaDropdownOption.NotSetted,
	districtId: DistrictDropdownOption.NotSetted,
	officeId: DefaultOffice.NotSetted,
	thematicAreas: [],
	districts: [],
	isAuth: false,
	reCaptchaConfig: {
		reCaptchaKey: ''
	},
	isInitiativeCreating: false,
	onSubmit: Function.prototype,
	setFieldValue: Function.prototype
};

// recaptcha key - 6LeO5o4UAAAAACtqupU5rIOHQqQDGFVEUyOXCWO7
